import { Icon, IconName } from '@frontend/icons';
import { Chip, Text } from '@frontend/design-system';

type AiInfoChipProps = {
  iconName: IconName;
  text: string;
};

export const AiIconChip = ({ iconName, text }: AiInfoChipProps) => {
  return (
    <Chip
      css={{
        fontSize: 'var(--fabric-typography-body-xs-font-size)',
        color: 'var(--fabric-color-text-primary)',
        background: `linear-gradient(90deg, var(--fabric-color-accent-blue-alpha-subtle) 0%, #def9f9 100%)`,
      }}
      leftElement={<Icon name={iconName} size={16} css={{ display: 'inline-block', verticalAlign: 'middle' }} />}
    >
      <Text as='span' css={{ display: 'inline-block', verticalAlign: 'middle' }}>
        {text}
      </Text>
    </Chip>
  );
};
